import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import IncidentDetails from "./IncidentDetails";
import IncidentHeader from "./IncidentHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import {
  loadIncidentAsync,
  selectIncident,
} from "../../../redux/slices/incident";
import { ComplianceInvestigationBox } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationBox";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page500 from "../../../pages/auth/Page500";

const Incident = () => {
  const [loading, setLoading] = useState(false);
  const [loadingIncidentId, setLoadingIncidentId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const incidentSelector = useAppSelector(selectIncident);

  const dispatch = useAppDispatch();

  let { profileNo, incidentId } = useParams();
  if (!profileNo || !incidentId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingIncidentId !== incidentId) {
    setLoadingIncidentId(incidentId);
    dispatch(loadIncidentAsync(incidentId));
    return <Loading />;
  }

  const incidentDetails = incidentSelector.incident;

  if (!incidentDetails) {
    return <Loading />;
  }

  if (!incidentDetails.response.ok) {
    if (incidentDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <IncidentHeader
            licenceProfile={licenceProfile}
            incidentDetails={incidentDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <IncidentDetails incidentDetails={incidentDetails} />
        </Col>
      </Row>
      {incidentDetails.complianceInvestigationDetails && (
        <Row>
          <Col className="col-12 col-sm-12 col-md-12">
            <ComplianceInvestigationBox
              complianceInvestigationDetails={
                incidentDetails.complianceInvestigationDetails
              }
              licenceProfile={licenceProfile}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            incidentDetails={incidentDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        incidentDetails={incidentDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default Incident;
